module.exports = {
	"empty_list": {
		"no_data_available": "Nenhum registro disponível para ser exibido.",
		"filter_case": "Caso tenha filtrado alguma informação,",
		"clear_filter": "limpe o filtro",
		"back_to_default_list": "para voltar a lista padrão"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/empty-list/pt-BR.yml
// module id = 581
// module chunks = 1